import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { catchError, Observable, throwError } from 'rxjs';
import { getAcceptLanguage } from '../helpers/getAcceptLanguage';
import { HttpHeaders } from '@angular/common/http';
import { AccountService } from './account.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PdvReportingService {

  constructor(private api: BaseApiService,
    private accountService: AccountService,) { }

  getKifKompletanPdf(params: any) {
    var lang = getAcceptLanguage.getLocalStorageLanguage();
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': lang,
      firmaid: this.accountService.context?.organizationId?.toString() || '',
      godina: this.accountService.context?.year?.toString() || '',
      Authorization: 'Bearer ' + this.accountService.accessToken.token,
    });
    return this.api.newRequest(
      'post',
      `${environment.apiUrl}pdv/reporting/kif-kompletan-datum`,
      {
        od: params.od,
        do: params.do,
      },
      {},
      {
        headers,
        responseType: 'blob',
      }
    );
  }

  getKufKompletanPdf(params: any) {
    var lang = getAcceptLanguage.getLocalStorageLanguage();
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': lang,
      firmaid: this.accountService.context?.organizationId?.toString() || '',
      godina: this.accountService.context?.year?.toString() || '',
      Authorization: 'Bearer ' + this.accountService.accessToken.token,
    });
    return this.api.newRequest(
      'post',
      `${environment.apiUrl}pdv/reporting/kuf-kompletan-datum`,
      {
        od: params.od,
        do: params.do,
      },
      {},
      {
        headers,
        responseType: 'blob',
        observe: 'response'
      }
    );
  }

  getKufKompletanExcel(params: any) {
    var lang = getAcceptLanguage.getLocalStorageLanguage();
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': lang,
      firmaid: this.accountService.context?.organizationId?.toString() || '',
      godina: this.accountService.context?.year?.toString() || '',
      Authorization: 'Bearer ' + this.accountService.accessToken.token,
    });
    return this.api.newRequest(
      'post',
      `${environment.apiUrl}pdv/reporting/kuf-kompletan-datum-excel`,
      {
        od: params.od,
        do: params.do,
      },
      {},
      {
        headers,
        responseType: 'blob',
        observe: 'response'
      }
    );
  }

  getKIfKompletanExcel(params: any) {
    var lang = getAcceptLanguage.getLocalStorageLanguage();
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': lang,
      firmaid: this.accountService.context?.organizationId?.toString() || '',
      godina: this.accountService.context?.year?.toString() || '',
      Authorization: 'Bearer ' + this.accountService.accessToken.token,
    });
    return this.api.newRequest(
      'post',
      `${environment.apiUrl}pdv/reporting/kif-kompletan-datum-excel`,
      {
        od: params.od,
        do: params.do,
      },
      {},
      {
        headers,
        responseType: 'blob',
        observe: 'response'
      }
    );
  }

  getPdvPrijavaPdf(params: any) {
    var lang = getAcceptLanguage.getLocalStorageLanguage();
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': lang,
      firmaid: this.accountService.context?.organizationId?.toString() || '',
      godina: this.accountService.context?.year?.toString() || '',
      Authorization: 'Bearer ' + this.accountService.accessToken.token,
    });
    return this.api.newRequest(
      'post',
      `${environment.apiUrl}pdv/reporting/pdv-prijava`,
      {
        mjesec: params.mjesec,
      },
      {},
      {
        headers,
        responseType: 'blob',
      }
    );
  }

  getObracunPDVaList(params: any): Observable<any> {
    return this.api
      .post('pdv/reporting/obracun-pdv-list', params)
      .pipe(catchError(this.handleError<[]>(`pdv/reporting/obracun-pdv-list`)));
  }

  obracunPDVKnjiziUFinancije(params: any): Observable<any> {
    return this.api
      .post('pdv/reporting/obracun-pdv-knjizi-u-financije', params)
      .pipe(catchError(this.handleError<[]>(`pdv/reporting/obracun-pdv-knjizi-u-financije`)));
  }

  autoEmailKnjizenjeReport(params: any): Observable<any> {
    return this.api
      .post('pdv/reporting/auto-email-knjizenje-report', params)
      .pipe(catchError(this.handleError<[]>('pdv/reporting/auto-email-knjizenje-report')));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      const errorMsg = `${operation} failed: ${error.message}`;

      return throwError(error);
    };
  }
}
